'use client'

import React, { FC, ReactNode, useContext } from 'react'
import { Text } from '../../../atoms'
import { TextTypes } from '../../../../types'
import { ViewIcon, IconSizes } from '../../../icons'
import { ComponentTranslationContext } from '../../../../providers'
import { MESSAGE_KEYS } from '../../../../constants/messageKeys'
import { TimelineEventVisibility } from '../types/TimelineEventTypes'

interface TimelineEventFooterProps {
    formattedDate?: string
    actorName?: string
    actorPopover?: React.ReactElement
    companyName?: string
    companyPopover?: React.ReactElement
    visibility?: TimelineEventVisibility
    isSystemEvent: boolean
}

export const TimelineEventFooter: FC<TimelineEventFooterProps> = ({
    formattedDate,
    actorName,
    actorPopover,
    companyName,
    companyPopover,
    visibility,
    isSystemEvent,
}) => {
    const { getLabel } = useContext(ComponentTranslationContext)

    const hasFooterText = formattedDate || actorName || actorPopover || companyName || companyPopover
    if (!hasFooterText && visibility !== TimelineEventVisibility.PUBLIC) return

    const shouldShowDash =
        formattedDate && (actorName || actorPopover || companyName || companyPopover || isSystemEvent)
    const shouldShowComma = (actorName || actorPopover) && (companyName || companyPopover)

    return (
        <Text type={TextTypes.SMALL_TEXT} tag="span" data-testid="timeline-event-footer">
            {formattedDate && formattedDate}
            {shouldShowDash && ' - '}
            {!isSystemEvent && (
                <>
                    {actorPopover && actorPopover}
                    {actorName && !actorPopover && actorName}
                    {shouldShowComma && ', '}
                    {companyPopover && companyPopover}
                    {companyName && !companyPopover && companyName}
                </>
            )}
            {isSystemEvent && getLabel(MESSAGE_KEYS.SYSTEM)}
            {visibility === TimelineEventVisibility.PUBLIC && (
                <span className="inline-block align-middle ml-0.5">
                    <ViewIcon size={IconSizes.SMALL} />
                </span>
            )}
        </Text>
    )
}
